import * as React from "react";
import AppModal from "../../common/components/AppModal";

type Props = {
    open: boolean;
    isLoading: boolean;
    taskTypeName?: string;
    onCancel: () => void;
    onConfirm: () => void;
};

const CustomizeWorkflowModal: React.FC<Props> = ({
    open,
    isLoading,
    taskTypeName,
    onCancel,
    onConfirm,
}) => {
    return (
        <AppModal
            centered
            width={680}
            open={open}
            closable={false}
            maskClosable
            onCancel={onCancel}
            className="alpha-modal"
            cancelButtonTitle="Keep standard workflow"
            onCancelClick={onCancel}
            cancelButtonProps={{
                disabled: isLoading,
            }}
            submitButtonTitle="Customize workflow"
            onSubmitClick={onConfirm}
            submitButtonProps={{
                loading: isLoading,
            }}
        >
            <div
                style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#13254C",
                    marginBottom: 16,
                }}
            >
                Customize workflow?
            </div>
            <div
                style={{
                    fontSize: 14,
                    color: "#5B6B8C",
                    marginBottom: 24,
                }}
            >
                {taskTypeName ?? "This task type"} currently uses the standard
                workflow.
            </div>
            <div
                style={{
                    border: "1px solid #F5C27A",
                    background: "#FFF7E8",
                    borderRadius: 8,
                    color: "#8B5A12",
                    padding: 16,
                    lineHeight: 1.6,
                }}
            >
                Custom workflow settings can make this project behave
                differently from standard Alpha Tasks projects. This may affect
                task templates, dashboard widgets, reports, action constraints,
                and user expectations.
            </div>
        </AppModal>
    );
};

export default CustomizeWorkflowModal;
